import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';  // ← ADD THIS
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppComponent } from './app.component';
import { PublicRoutingModule } from './public/public-routing.module';
import { CoreUiModule } from './shared/core-ui.module';
import { AppRoutingModule } from './app-routing.module';

import { AuthGuardService } from './auth/auth-guard.service';
import { PermissionService } from './auth/permission.service';
import { PublicModule } from './public/public.module';
import { UtilServiceService } from './_services/utilService/util-service.service';
import { ProfilesService } from './_services/admin/profiles.service';
import { AuthenticationService } from './auth/authentication.service';
import { ApiService } from './_services/api.service';
import { ProfileFeaturesService } from './_services/profile-features.service';
import { UsersService } from './_services/admin/users.service';
import { ErrorUtil } from './_utilities/error';
import { TokenInterceptor } from './auth/token-interceptor';


import { CustomersService } from './_services/customers.service';
import { WebSocketsService } from './_services/web-sockets.service';
import { NotificationsService } from './_services/notifications.service';
import { SettingService } from './_services/admin/setting.service';

import { HeaderTitleService } from './_services/header-title.service';
import { MenuService } from './_services/menu.service';
import { BreadcrumbService } from './_services/breadcrumb.service';
import { InventoryService } from './_services/inventory.service';
import { ProductService } from './_services/product.service';
import { ModalServiceService } from './_services/modal-service.service';
import { TasksService } from './_services/tasks.service';
import { DeleteRecordService } from './_services/delete-record.service';
import { AssetService } from './_services/asset.service';
import { DynamicFormService } from './_services/dynamic-form.service';
import { SignUpService } from './_services/sign-up.service';
import { SalesOrdersService } from './_services/sales-orders.service';
import { MagnumFormService } from './_services/magnum-form.service';
import { TimezonePickerService } from './_services/timezone-picker.service';
import { RolesService } from './_services/admin/roles.service';
import { LeaveService } from './_services/leave.service';
import { ScheduleService } from './_services/schedule.service';
import { ChubbServicesService } from './_services/chubb-services.service';
import { TeamService } from './_services/team.service';
import { ChecklistService } from './_services/checklist.service';
import { VisitsService } from './_services/visits.service';
import { PmvService } from './_services/pmv.service';
import { CustomerSurveyService } from './_services/customer-survey.service';
import { SterraFormService } from './_services/sterra-form.service';
import { ResetPasswordComponent } from './dashboard/setup/users/reset-password/reset-password.component';
import { DynamicTableColumnsService } from './_services/dynamic-table-column.service';
import { LanguageTranslateService } from './_services/language-translate.service';
import { WorkflowService } from './_services/workflow.service';
import { EmailTemplateService } from './_services/email-template.service';
import { GridSelectionService } from './_services/grid-selection.service';
import { OnBoardRoutingModule } from './on-board/on-board-routing.module';
import { OnBoardModule } from './on-board/on-board.module';
import { MixpanelService } from './_services/mixpanel.service';
import { provideLottieOptions } from 'ngx-lottie';
import { QrExportService } from './_services/qr-export.service';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxSpinnerModule } from 'ngx-spinner';
import { OptionsRequisitionOptionsComponent } from './dashboard/inventory/global-requisition/options-requisition-options/options-requisition-options.component';
import { OptionsRequisitionNoteComponent } from './dashboard/inventory/global-requisition/options-requisition-note/options-requisition-note.component';
import { ChunkLoadErrorHandler } from './chunk-load-error.handler';
import { DynamicSkillsService } from './_services/admin/dynamic-skills.service';

@NgModule({ 
  declarations: [
    AppComponent,
    ResetPasswordComponent,
    OptionsRequisitionOptionsComponent,
    OptionsRequisitionNoteComponent
  ],
  
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,  // ← ADD THIS - provides <router-outlet>
    ModalModule.forRoot(),
    CoreUiModule,
    AppRoutingModule,
    PublicModule,
    PublicRoutingModule,
    OnBoardRoutingModule,
    OnBoardModule,
    DragDropModule,
    NgxSpinnerModule,
    
  ], 
  
  providers: [
    AuthGuardService,
    ApiService,
    AuthenticationService,
    PermissionService,
    ProfileFeaturesService,
    UsersService,
    UtilServiceService,
    ProfilesService,
    ErrorUtil,
    WebSocketsService,
    SettingService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    NotificationsService,
    HeaderTitleService,
    MenuService,
    BreadcrumbService,
    CustomersService,
    InventoryService,
    ProductService,
    ModalServiceService,
    TasksService,
    DeleteRecordService,
    AssetService,
    DynamicFormService,
    SignUpService,
    SalesOrdersService,
    MagnumFormService,
    TimezonePickerService,
    RolesService,
    LeaveService,
    ScheduleService,
    ChubbServicesService,
    TeamService,
    VisitsService,
    ChecklistService,
    PmvService,
    CustomerSurveyService,
    SterraFormService,
    DynamicTableColumnsService,
    LanguageTranslateService,
    WorkflowService,
    EmailTemplateService,
    GridSelectionService,
    MixpanelService,
    QrExportService,
    DynamicSkillsService,
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
     
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }